import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';

const GooglePayCaption = ({ type  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("span", {
        className: "google-pay-caption"
    }, type && type === 'express-checkout' && getLabel('checkout.express.google.pay.action.payWith'), /*#__PURE__*/ React.createElement(Icon, {
        "data-t": "google-pay-icon",
        color: "white",
        name: "google-checkout-button-icon",
        viewBox: "0 0 80 38.1",
        width: 48,
        height: type === 'express-checkout' ? 23 : 48
    }));
};
const GooglePayButton = ({ disabled , type , onClick  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(Button, {
        disabled: disabled,
        className: "cart-navigation__button google-pay",
        "data-t": type,
        caption: /*#__PURE__*/ React.createElement(GooglePayCaption, {
            type: type
        }),
        onClick: onClick,
        "aria-label": getLabel('checkout.payment.method.googlepay')
    });
};

export { GooglePayButton };
//# sourceMappingURL=GooglePayExpressCheckoutButton.js.map
